export default __webpack_public_path__ + "static/media/fortress-skid-plate.a2f9ef2b.jpg";